// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"381":"3fbe61bc","844":"ce71acfd"}[chunkId] + ".css";
};